import APIClientEnclave from '../../Services/AxiosClientEnclave';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const fetchAllReports = async (queryPayload: any) => {
  try {
    const response: any = await APIClientEnclave({
      url: URL_ENDPOINTS?.FINANCIAL_INFO?.GETALLREPORTS,
      method: 'get',
      data: queryPayload,
    });
    return response;
  } catch (err) {
    return null;
  }
};

export const fetchTaxForms = async (queryPayload: any) => {
  try {
    const response: any = await APIClientEnclave({
      url: URL_ENDPOINTS?.FINANCIAL_INFO?.GETTAXFORMS,
      method: 'get',
      data: queryPayload,
    });
    return response;
  } catch (err) {
    return null;
  }
};

export const fetchReportId = async (queryPayload: any) => {
  try {
    const response: any = await APIClientEnclave({
      url: URL_ENDPOINTS?.FINANCIAL_INFO?.EXPORT_REPORT,
      method: 'post',
      data: queryPayload,
    });
    return response;
  } catch (err) {
    return null;
  }
};

export const fetchReportData = async (queryPayload: any) => {
  try {
    const response: any = await APIClientEnclave({
      url: URL_ENDPOINTS?.FINANCIAL_INFO?.GETREPORT + `?reportId=${queryPayload.reportId}` + `&exportId=${queryPayload.exportId}`,
      method: 'get',
      data: queryPayload,
    });
    return response;
  } catch (err) {
    return null;
  }
};

export const fetchTaxForm = async (queryPayload: any) => {
  try {
    const response: any = await APIClientEnclave({
      url: URL_ENDPOINTS?.FINANCIAL_INFO?.GETTAXFORMPDF 
      + `?RECID=${queryPayload.RECID}` 
      + `&PayerID=${queryPayload.PayerID}` 
      + `&FormID=${queryPayload.FormID}` 
      + `&year=${queryPayload.year}` 
      + `&FChar=${queryPayload.FChar}`,
      method: 'get',
      data: queryPayload,
    });
    return response;
  } catch (err) {
    return null;
  }
};
